import { useEffect, useState } from 'react';
import { _t } from '@/i18n/t';

const ROLL_MS = 250;

function RollingDigit({ digit }: { digit: string }) {
  const [state, setState] = useState({ current: digit, previous: null as string | null, turn: 0 });

  useEffect(() => {
    setState(prev => (prev.current === digit ? prev : { current: digit, previous: prev.current, turn: prev.turn + 1 }));
  }, [digit]);

  useEffect(() => {
    if (state.previous === null) return;
    const timer = window.setTimeout(() => setState(prev => ({ ...prev, previous: null })), ROLL_MS);
    return () => clearTimeout(timer);
  }, [state.previous, state.turn]);

  return (
    <span className="ob-odo__digit">
      {state.previous !== null && (
        <span key={`out-${state.turn}`} className="ob-odo__value ob-odo__value--out" aria-hidden="true">
          {state.previous}
        </span>
      )}
      <span key={`in-${state.turn}`} className={state.turn > 0 ? 'ob-odo__value ob-odo__value--in' : 'ob-odo__value'}>
        {state.current}
      </span>
    </span>
  );
}

/**
 * The silent tally. Every digit it shows was counted off the scan stream, so it
 * is allowed to be precise — it never rounds up to look busier than the run was.
 */
export default function SignalsOdometer({ value }: { value: number }) {
  const digits = String(value).split('');

  return (
    <span
      className="ob-odo"
      data-testid="onboarding-scan-signals"
      aria-live="polite"
      aria-label={_t('onboarding.crawl.signals.ariaLabel', { count: value })}
    >
      <span className="ob-odo__digits" aria-hidden="true">
        {digits.map((digit, i) => (
          <RollingDigit key={digits.length - i} digit={digit} />
        ))}
      </span>
      <span className="ob-odo__unit text-muted-foreground">
        {value === 1 ? _t('onboarding.crawl.signals.unitOne') : _t('onboarding.crawl.signals.unitMany')}
      </span>
    </span>
  );
}
